<div [ngClass]="disabled() ? 'link-button disabled' : 'link-button'" (click)="onClick($event)">
    <div class="icon-layout">
        @if (iconClass()) {
            <i [class]="iconClass() + ' link-icon'"></i>
        }
        @else if (icon()) {
            <app-svg-icon [icon]="icon()"></app-svg-icon>
        }
        <ng-content></ng-content>
    </div>
</div>